import { useQuery } from '@tanstack/react-query'
import { MAIN_REJESTR_API_SHORT } from '../../../../components/utils/consts.js'
import { useSelector } from 'react-redux'
import { getData } from '../../../app/getters/getData.js'
import { getList } from '../../../app/getters/getList.js'

export const useListaElementow = (query = '', enabled = true, filterType = null) => {
    const listaParam = query ? '/lista-dt' : '/lista'
    const accountType = useSelector((state) => state.user.role)
    const accountTypeParam = accountType === 'wp' ? '' : accountType

    let fullQuery = query
    if (filterType) {
        const separator = query ? '&' : '?'
        fullQuery = `${query}${separator}filter_type=${filterType}`
    }

    let endpoint = `${accountTypeParam}/${MAIN_REJESTR_API_SHORT}${listaParam}${fullQuery}`
    let queryKey = [`lista_projektow__${endpoint}`]

    return useQuery({
        queryKey,
        queryFn: () => getData(endpoint),
        enabled: enabled,
        refetchOnMount: true,
        refetchInterval: 1000 * 60 * 15,
    })
}

export const fetchListaElementow = async (rola) => {
    const roleParam = rola === 'wp' ? '' : `${rola}/`
    const list = await getList(`/${roleParam}${MAIN_REJESTR_API_SHORT}/lista`)
    return list || []
}
